<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Listas de Produtos</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Listas de Produtos da Termometria</h1>
      </el-col>
    </el-row>

    <el-row v-if="permissao.lista_preco_termometria" :gutter="10">
      <el-col :span="24">
        <el-button style = "float: left; margin-left: 10px;" type="primary" @click="importarProdutosCSV()">
          Importar Produtos de Arquivo .CSV
        </el-button>
      </el-col>
    </el-row>

    <br/>
    
    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="lista"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <el-table-column prop="id" label="Id" width="60" sortable></el-table-column>
          <el-table-column prop="nome" label="Nome" min-width="150" sortable></el-table-column>
          <el-table-column prop="data_inicio" label="Inicio" width="110" sortable></el-table-column>
          <el-table-column prop="data_fim" label="Fim" width="110" sortable></el-table-column>
          <el-table-column prop="data_validade" label="Validade" width="110" sortable></el-table-column>
          <el-table-column label="Ações" width="200">
            <template v-slot="{ row }">
              <el-button size="mini" type="primary" @click="verListaPrecos(row.id)" title="Ver Preços da Lista">Ver Produtos</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      loading: true,
      lista: [],
      permissao: {},
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.lista_preco_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.getDados();
  },
  methods: {
    async getDados() {
      this.loading = true;
      try {
        const response = await axios.get(url + "/termometria-produto-lista/", {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.lista = response.data;
        }
      } catch (err) {
        console.error("Erro ao buscar clientes:", err);
      } finally {
        this.loading = false;
      }
    },
    importarProdutosCSV() {
      this.$router.push("/termometria/produtos/importacao3")
    },
    verListaPrecos(id) {
      this.$router.push("/termometria/produto/lista/preco/"+id)
    }

  },
};
</script>

<style>
.el-row-topo {
  margin-top: 10px;
}
</style>
